// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavMenu_nav-menu__oo8os {
  flex-grow: 1;
  padding-inline-end: 6rem;
}

.NavMenu_nav-menu__list__ynbba {
  display: flex;
  align-items: center;
}

.NavMenu_nav-menu__list-item__yDVDh {
  display: flex;
  align-items: center;
}

.NavMenu_nav-menu__list-item__yDVDh img {
  width: 2.8rem;
  height: 2.8rem;
  object-fit: contain;
}

.NavMenu_nav-menu__list-item__yDVDh:first-child {
  margin-inline-end: auto;
}

.NavMenu_nav-menu__list-item__yDVDh:not(:nth-child(2))::before {
  content: "";
  height: 30px;
  width: 1px;
  margin-inline: 2rem;
  background-color: var(--white-dark);
}

.NavMenu_nav-menu__list-item__yDVDh:first-child::before {
  margin-inline-start: 0;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .NavMenu_nav-menu__oo8os {
    padding-inline-end: 2rem;
  }

  .NavMenu_nav-menu__list-item__yDVDh:not(:nth-child(2))::before {
    margin-inline: 1.5rem;
  }

  .NavMenu_nav-menu__list-item__yDVDh:first-child::before {
    margin-inline-start: 0;
  }

  .NavMenu_nav-menu__list-item__yDVDh img {
    width: 2rem;
    height: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Navbar/NavMenu/NavMenu.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".nav-menu {\n  flex-grow: 1;\n  padding-inline-end: 6rem;\n}\n\n.nav-menu__list {\n  display: flex;\n  align-items: center;\n}\n\n.nav-menu__list-item {\n  display: flex;\n  align-items: center;\n}\n\n.nav-menu__list-item img {\n  width: 2.8rem;\n  height: 2.8rem;\n  object-fit: contain;\n}\n\n.nav-menu__list-item:first-child {\n  margin-inline-end: auto;\n}\n\n.nav-menu__list-item:not(:nth-child(2))::before {\n  content: \"\";\n  height: 30px;\n  width: 1px;\n  margin-inline: 2rem;\n  background-color: var(--white-dark);\n}\n\n.nav-menu__list-item:first-child::before {\n  margin-inline-start: 0;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .nav-menu {\n    padding-inline-end: 2rem;\n  }\n\n  .nav-menu__list-item:not(:nth-child(2))::before {\n    margin-inline: 1.5rem;\n  }\n\n  .nav-menu__list-item:first-child::before {\n    margin-inline-start: 0;\n  }\n\n  .nav-menu__list-item img {\n    width: 2rem;\n    height: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav-menu": `NavMenu_nav-menu__oo8os`,
	"nav-menu__list": `NavMenu_nav-menu__list__ynbba`,
	"nav-menu__list-item": `NavMenu_nav-menu__list-item__yDVDh`
};
export default ___CSS_LOADER_EXPORT___;
